import * as React from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import AlertTitle from '@mui/material/AlertTitle';
import CircularProgress from '@mui/material/CircularProgress';
import Backdrop from '@mui/material/Backdrop';
import Paper from '@mui/material/Paper';
import Alert from '@mui/material/Alert';


function PasswordChangeUi({ isPopupOpened, currentPassword, currentPasswordErrorState, currentPasswordErrorMessage, handleOnChange, newPassword, newPasswordErrorState, newPasswordErrorMessage, reNewPassword, reNewPasswordErrorState, reNewPasswordErrorMessage, overAllError, isFormSubmitButtonClicked, overAllErrorMessage, errorFromServer, setIsPopupOpened, handleSubmit, isFormSubmitted }) {
  return (
    <Backdrop
              sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
              open={isPopupOpened}
              onClick={() => {
                return;
              }}
            >
            <Box
            sx={{
              display: 'flex',
              position: 'absolute',
              top: "10px",
              zIndex: 2,
              flexWrap: 'wrap',
              '& > :not(style)': {
                m: 1,
                width: '400px',
                minHeight: '380px',
                maxHeight: '560px',
                overflowY: "auto"
              },
            }}
             >
            <Paper elevation={1} >
            <Typography variant="h6" component="h1" gutterBottom style={{ fontWeight: 'bold', marginTop: "10px" }}>
              Change Password
            </Typography>
            <Divider variant="hr" style={{ borderBottom: "2px solid gray" }} />
            <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
            <TextField
                margin="normal"
                required
                fullWidth
                name="currentPassword"
                label="Current Password"
                type="password"
                value={currentPassword}
                id="currentPassword"
                variant="standard"
                error={currentPasswordErrorState}
                helperText={currentPasswordErrorMessage}
                autoComplete="current-password"
                onChange={handleOnChange}
              />
              <TextField
                margin="normal"
                required
                fullWidth
                name="newPassword"
                label="New Password"
                type="password"
                value={newPassword}
                id="newPassword"
                variant="standard"
                error={newPasswordErrorState}
                helperText={newPasswordErrorMessage}
                autoComplete="current-password"
                onChange={handleOnChange}
              />
              <TextField
                margin="normal"
                required
                fullWidth
                name="reNewPassword"
                label="Reenter New Password"
                type="password"
                value={reNewPassword}
                id="reNewPassword"
                variant="standard"
                error={reNewPasswordErrorState}
                helperText={reNewPasswordErrorMessage}
                autoComplete="current-password"
                onChange={handleOnChange}
              />
              { (overAllError && isFormSubmitButtonClicked) ? <Alert severity="error" style={{ marginBottom: "10px", textAlign: "left" }}>{overAllErrorMessage}</Alert> : "" }
              { (errorFromServer && isFormSubmitButtonClicked) ? <Alert severity="error" style={{ marginBottom: "10px", textAlign: "left" }}>{errorFromServer}</Alert> : "" }
              <Alert severity="info" style={{ textAlign: "left" }}>
                <AlertTitle style={{ textAlign: "left" }}>Note</AlertTitle>
                Please ensure it has at least 8 characters, including at least one lowercase letter, one uppercase letter, one digit, and one special character.
              </Alert>
              <Grid container spacing={2} justifyContent="center" alignItems="center" style={{ marginTop: "8px" }}>
              <Grid item>
                <Button variant="outlined" onClick={ () => { setIsPopupOpened(false) }}>Cancel</Button>
              </Grid>
              <Grid item>
                <Button variant="contained" onClick={handleSubmit}>{ isFormSubmitted ? <CircularProgress style={{ color: "white", height: "24px", width: "24px" }} /> : "Change" }</Button>
              </Grid>
            </Grid>
              </Container>
            </Paper>
            </Box>
            </Backdrop>
  )
}

export default PasswordChangeUi